module.exports = __webpack_public_path__ + "img/paragraph-spacing.a2d69c0c.svg";